/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */

export class BucketdeletefileForm {
  public fileName: string;

  constructor(bucketdeletefileForm: any) {
    this.fileName = bucketdeletefileForm.fileName || '';
  }
}
